import React from 'react';
import MoreHoriz from '@mui/icons-material/MoreHoriz';

import PropTypes from 'prop-types';

import { Button } from 'uikit/buttons';
import { Menu } from 'uikit/menus';

const AppHeader = ({
  options,
}) => (
  <Menu
    shouldAnimate={false}
    component={(
      <Button
        size="xsmall"
        variant="ghost"
        icon={<MoreHoriz />}
      />
        )}
  >
    <ul>
      {options}
    </ul>
  </Menu>
);

AppHeader.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default React.memo(AppHeader);
